import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ViewModeContextType {
  isCustomerOnlyMode: boolean;
  toggleCustomerOnlyMode: () => void;
  setCustomerOnlyMode: (enabled: boolean) => void;
}

const ViewModeContext = createContext<ViewModeContextType | undefined>(undefined);

export const useViewMode = () => {
  const context = useContext(ViewModeContext);
  if (context === undefined) {
    throw new Error('useViewMode must be used within a ViewModeProvider');
  }
  return context;
};

interface ViewModeProviderProps {
  children: ReactNode;
}

export const ViewModeProvider: React.FC<ViewModeProviderProps> = ({ children }) => {
  const [isCustomerOnlyMode, setIsCustomerOnlyMode] = useState(false);

  const toggleCustomerOnlyMode = () => {
    setIsCustomerOnlyMode(prev => !prev);
  };

  const setCustomerOnlyMode = (enabled: boolean) => {
    setIsCustomerOnlyMode(enabled);
  };

  const value = {
    isCustomerOnlyMode,
    toggleCustomerOnlyMode,
    setCustomerOnlyMode
  };

  return (
    <ViewModeContext.Provider value={value}>
      {children}
    </ViewModeContext.Provider>
  );
};
